<div dialog-header>
  <h4>Emulate Dealer</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

<div class="form">
  <div class="dealer-emulate-row">
    <p>Current Dealership</p>
    <input ui-input [readOnly]="true" [value]="user.name" />
  </div>
  <div class="dealer-emulate-row">
    <p>New Dealership Name or Number</p>
    <div>
      <input ui-input [formControl]="dealerControl" [appAutocomplete]="autocomplete" />
      <app-autocomplete #autocomplete="appAutocomplete">
        <ng-template appAutocompleteContent>
          @if (dealers(); as dealers) {
            @for (dealer of dealers; track dealer) {
              @if (dealer.status) {
                <app-option [value]="dealer.cmsDealerNumber" (optionClicked)="setSelectedDealerOption(dealer)">
                  {{ dealer.dealerName }} - {{ dealer.cmsDealerNumber }}
                </app-option>
              }
            }
          }
        </ng-template>
      </app-autocomplete>
    </div>
  </div>
</div>

<div class="dialog-actions">
  <button ui-button type="danger" (click)="resetDealer()">RESET DEALER</button>
  <button ui-button (click)="emulateDealer()" [disabled]="!isValidDealer">Confirm</button>
  <button ui-button type="secondary" (click)="close()">Cancel</button>
</div>
